import React, { useEffect } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { activityHubUsers } from "reduxSlices/organizationUsersSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable-next-line max-len */
import TaskUserSelector from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskUserSelector"

const TaskAssigneeSelector = ({ className = "" }) => {
  const users = useSelector(activityHubUsers, isEqual)

  const { addAssigneeId, taskAssigneeIds, taskMemberIds } = useTaskFormContext()

  useEffect(() => {
    window.dispatchEvent(new window.Event("resize"))
  }, [taskAssigneeIds.length])

  const selectableUsers = users.reduce((userList, user) => {
    if (user.active && !taskAssigneeIds.includes(user.id)) {
      userList.push(
        {
          ...user,
          ...(taskMemberIds.includes(user.id) && { marker: "Member" }),
        },
      )
    }
    return userList
  }, [])

  return (
    <TaskUserSelector
      addUserId={addAssigneeId}
      className={className}
      taskUserType="Assignees"
      users={selectableUsers}
    />
  )
}

TaskAssigneeSelector.propTypes = {
  className: types.string,
}

export default TaskAssigneeSelector
